module.exports = __webpack_public_path__ + "img/_posmap2.e2a7d4e0.png";